import React, { Component, FormEvent } from 'react';
import { RootState } from '../../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import MessageUtil from '../../../../../util/MessageUtil';
import FormicaInput from 'components/custom/FormicaInput';
import RoleHelper from '../../../../../RoleHelper';
import { FormicaProps, withFormica } from '../../../../../helpers/withFormica';
import { ApiActionJsonModel, ApiActionVariableParameter } from '../../../../../domain/collection/rule/action/ActionDomains';
import { ActionState } from '../../../../../redux/reducers/ActionReducer';
import { changeAction, changeActionApiVariableParameter, changeActionIsUpdate, clearAction } from '../../../../../redux/actions/ActionActions';
import { enterComponent, leaveComponent } from '../../../../../redux/actions/ComponentActions';
import AnimatedButton from '../../../../custom/AnimatedButton';
import ComponentName from '../../../../../constant/ComponentName';
import LanguageUtil from '../../../../../util/LanguageUtil';

class ApiParametersCreatorComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const { parameter } = this.state;
    return (
      <div className={'flex w-full gap-x-4 items-center mb-5 justify-start px-1'}>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e) => this.onKeyChange(e)}
            value={parameter.key}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.key', defaultMessage: 'Key' })}
            data-testid={`${ComponentName.ACTION}_parameter_key_creator_input`}
          />
        </div>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e) => this.onValueChange(e)}
            value={parameter.value}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.value', defaultMessage: 'Value' })}
            data-testid={`${ComponentName.ACTION}_parameter_value_creator_input`}
          />
        </div>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e) => this.onDescriptionChange(e)}
            value={parameter.description}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.description', defaultMessage: 'Description' })}
            data-testid={`${ComponentName.ACTION}_parameter_description_creator_input`}
          />
        </div>
        <div className={''}>
          <AnimatedButton
            disabled={!RoleHelper.canEdit('Action')}
            onClick={this.handleSubmit}
            customSize={'sm'}
            customType={'primary'}
            icon={'add'}
            text={LanguageUtil.get({ id: 'common.button.add', defaultMessage: 'Add' })}
            data-testid={`${ComponentName.ACTION}_parameter_key_add_button`}
          />
        </div>
      </div>
    );
  }

  private onKeyChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, key: e.currentTarget.value } });
  };

  private onValueChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, value: e.currentTarget.value } });
  };

  private onDescriptionChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, description: e.currentTarget.value } });
  };

  private handleSubmit = () => {
    const {
      action: { action },
      changeAction,
      changeActionApiVariableParameter,
    } = this.props;
    const { parameter } = this.state;
    if ((action as ApiActionJsonModel).parameters?.find((p) => p.key === parameter.key)) {
      MessageUtil.warning({
        summary: LanguageUtil.get({ id: 'messages.parameterWithThisKeyAlreadyExist', defaultMessage: 'Parameter with this key already exist.' }),
        detail: (
          <div>
            {LanguageUtil.get(
              {
                id: 'messages.failed.cantSaved',
                defaultMessage: `${(action as ApiActionJsonModel).name} can't saved.`,
              },
              { 0: `${(action as ApiActionJsonModel).name}` },
            )}
          </div>
        ),
      });
      return false;
    }
    if (parameter.key && parameter.value && parameter.key.trim().length > 0 && parameter.value.trim().length > 0) {
      (action as ApiActionJsonModel).parameters = [...((action as ApiActionJsonModel).parameters || []), parameter];
      changeAction(action);
      changeActionApiVariableParameter(action);
      this.setState({ parameter: { ...this.state.parameter, key: '', value: '', description: '' } });
    } else {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'messages.valueAndKeyAreRequired' }),
      });
    }
  };
}

class State {
  parameter: ApiActionVariableParameter = {
    key: '',
    value: '',
    description: '',
    isActive: true,
  };
}

interface Props extends ReduxProps, FormicaProps {}

const mapStateToProps = (state: RootState) => ({
  action: state.action as ActionState,
  isUpdate: state.action.isUpdate,
  lastCategory: state.page.lastCategory,
});

const mapDispatchToProps = {
  changeActionIsUpdate,
  changeActionApiVariableParameter,
  changeAction,
  clearAction,
  enterComponent,
  leaveComponent,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(ApiParametersCreatorComponent));
